/* global window, HTMLElement */

import { readAttribute } from '@helga-agency/ui-tools';

export default class AnchorVisibilityHandler extends HTMLElement {
    private readonly activeLinkClass: string;
    private anchorLinkElement: Element | null = null;

    constructor() {
        super();

        this.activeLinkClass = readAttribute(
            this,
            'data-active-link-class',
            {
                validate: (value) => !!value,
                expectation: 'a non-empty value',
            },
        );
    }

    connectedCallback() {
        this.anchorLinkElement = this.getAnchorLinkElement();
        this.registerAnchorIntersectionListener();
    }

    private getAnchorLinkElement() {
        return this.querySelector('[data-anchor-navigation-link]');
    }

    private getAnchorHashValue() {
        return this.anchorLinkElement?.hash.substring(1);
    }

    private registerAnchorIntersectionListener() {
        window.addEventListener('anchorIntersect', this.checkAnchorVisibility.bind(this));
    }

    private checkAnchorVisibility(event: any) {
        if (event.detail.anchorId === this.getAnchorHashValue()) {
            this.anchorLinkElement?.classList.add(this.activeLinkClass);

            this.anchorLinkElement?.scrollIntoView({ behavior: 'smooth' });
        } else {
            this.anchorLinkElement?.classList.remove(this.activeLinkClass);
        }
    }

    public static defineElement(): void {
        if (!window.customElements.get('anchor-visibility-handler')) {
            window.customElements.define('anchor-visibility-handler', AnchorVisibilityHandler);
        }
    }
}
